
import React, { useState } from 'react';
import { COLORS } from '../constants';

interface LeadModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const LeadModal: React.FC<LeadModalProps> = ({ isOpen, onClose }) => {
  const [segment, setSegment] = useState<'Home' | 'Business'>('Home');

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white w-full max-w-xl rounded-3xl p-10 shadow-2xl overflow-hidden">
        <button onClick={onClose} className="absolute top-6 right-6 p-2 hover:bg-gray-100 rounded-full transition-colors">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
        </button>

        <h3 className="text-3xl font-bold mb-2">Get in touch</h3>
        <p className="text-slate-500 mb-8">Please select your segment to help us provide you with the best service.</p>

        <div className="flex gap-4 mb-8">
          <button 
            onClick={() => setSegment('Home')}
            className={`flex-1 py-4 rounded-2xl font-bold transition-all border-2 ${segment === 'Home' ? 'border-emerald-500 bg-emerald-50 text-emerald-700' : 'border-gray-100 hover:border-gray-200'}`}
          >
            🏠 Home
          </button>
          <button 
            onClick={() => setSegment('Business')}
            className={`flex-1 py-4 rounded-2xl font-bold transition-all border-2 ${segment === 'Business' ? 'border-emerald-500 bg-emerald-50 text-emerald-700' : 'border-gray-100 hover:border-gray-200'}`}
          >
            🏢 Business
          </button>
        </div>

        <form className="space-y-4" onSubmit={(e) => { e.preventDefault(); alert('Lead captured!'); onClose(); }}>
          <div>
            <label className="block text-xs font-bold uppercase tracking-widest text-slate-400 mb-2">Full Name</label>
            <input type="text" required className="w-full bg-gray-50 border border-gray-100 rounded-xl px-4 py-3 outline-none focus:border-emerald-500 transition-colors" placeholder="John Doe" />
          </div>
          <div>
            <label className="block text-xs font-bold uppercase tracking-widest text-slate-400 mb-2">Email Address</label>
            <input type="email" required className="w-full bg-gray-50 border border-gray-100 rounded-xl px-4 py-3 outline-none focus:border-emerald-500 transition-colors" placeholder="john@example.com" />
          </div>
          <button 
            className="w-full text-white font-bold py-4 rounded-xl shadow-lg mt-4 transition-transform active:scale-95"
            style={{ backgroundColor: COLORS.novusGreen }}
          >
            Submit Request
          </button>
        </form>
      </div>
    </div>
  );
};

export default LeadModal;
